import React from "react";
import PropTypes from "prop-types";
import { Badge, Button } from "reactstrap";
import { BsXCircle } from "react-icons/bs";

function FilterBadge(props) {
  const { badgeName, onDeleteClick } = props;
  return (
    <Badge className="py-1 px-2 ml-3 my-1 badge-pill text-white">
      <span>{badgeName}</span>
      <Button
        type="button"
        className="p-0 remove-filter-button"
        onClick={onDeleteClick}
      >
        <BsXCircle size="1em" />
      </Button>
    </Badge>
  );
}

FilterBadge.propTypes = {
  onDeleteClick: PropTypes.func.isRequired,
  badgeName: PropTypes.string.isRequired
};

export default FilterBadge;
